import { h, Component } from 'preact'

import Title from '../../Title'
import theme from '../../Theme/style.css'
import style from './style.css'
import errors from '../../strings/errors'
import { lowerCase } from '../../utils/string'
import { sendScreen } from '../../../Tracker'
import { localised } from '../../../locales'

class GenericError extends Component {
  componentDidMount() {
    sendScreen([`${lowerCase(this.props.error.name)}`])
  }
  render ({translate, error}) {
    const { message, instruction } = errors[error.name]
    return (
      <div>
        <Title title={translate(message)} subTitle={translate(instruction)} />
        <div className={theme.thickWrapper}>
          <span className={`${theme.icon}  ${style.icon}`} />
        </div>
      </div>
    )
  }
}

export default localised(GenericError)



// WEBPACK FOOTER //
// ./components/crossDevice/GenericError/index.js